module.exports = __webpack_public_path__ + "static/media/tick_white.a7a54a72.png";